import React from "react";

export const SingleProductImageFocusedPrice = ({
  product,
  isGiftCardProduct,
  isRetailMerchant,
}: any) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price / 100);
  };

  if (!product.available) {
    return (
      <div className="flex items-center">
        <p
          className={["line-through font-normal text-base leading-6"].join(" ")}
        >
          {formatPrice(product.price)}
        </p>
        <span
          className={["ml-2 truncate font-normal text-base leading-6"].join(
            " "
          )}
        >
          Unavailable
        </span>
      </div>
    );
  }

  return (
    <p className="font-normal text-base leading-6">
      {!isGiftCardProduct ? formatPrice(product.price) : "Custom Value"}
    </p>
  );
};
